module.exports = __webpack_public_path__ + "img/yellow.50249f56.png";